module.exports = __webpack_public_path__ + "static/media/30.c056f4d6.jpg";